import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as classnames from 'classnames';
import { LegacyDevice } from 'console/device/device';
import { GetDeviceIconWithTooltip } from 'console/device/icons';
import { DeviceThermometersView } from 'console/tabs/legacy/state/components/thermometers-view';
import { TargetTempsControl, ThermostatExtModeButton, } from 'console/dashboards/zth/control-block/thermostat-ext-modes-control';
import audio from 'console/audio/zth-dashboard-alert.mp3';
import { isThermometerFailing } from './utils';
export function DeviceCard(props) {
    const { device, server_time, config, onGoToDevice, onModeChange } = props;
    let fail;
    const modes = device.thermostat_ext_modes_config || {};
    if (device.last_boiler_state?.fail) {
        fail = true;
    }
    else {
        for (const therm of LegacyDevice.active_thermometers(device?.thermometers || [])) {
            if (isThermometerFailing(therm)) {
                fail = true;
                break;
            }
        }
    }
    function onClickMode(id) {
        return () => onModeChange(id);
    }
    return (_jsxs("div", { className: classnames('ui-card', { 'ui-card-fail': fail }), children: [_jsxs("h1", { onClick: onGoToDevice, title: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0443", children: [_jsx(GetDeviceIconWithTooltip, { state: device.iconState }), _jsx("span", { children: device.name }), _jsx("span", { className: "zth-dashboard-go-to-device" })] }), _jsx(FailDashBoard, { fail: device.last_boiler_state?.fail || false }), config.enable_alert && fail && (_jsx("audio", { id: 'alert', hidden: true, src: audio, autoPlay: true })), config.enable_zones && _jsx(TargetTempsControl, { device_id: device.id }), _jsx("div", { style: { textAlign: 'center' }, children: config.enable_modes &&
                    Object.entries(modes).map(([mode_id, mode]) => {
                        if (mode?.active && !mode?.hidden) {
                            const id = parseInt(mode_id, 10);
                            return (_jsx(ThermostatExtModeButton, { name: mode.name, selected: id === device.thermostat_ext_mode, show_temp: false, onClick: onClickMode(id) }, mode_id));
                        }
                        return null;
                    }) }), _jsx("div", { style: { marginTop: '10px' } }), config.enable_temperature && (_jsx(DeviceThermometersView, { micro: true, r_device: device, server_time: server_time }))] }, device.id));
}
export function FailDashBoard({ fail }) {
    if (fail) {
        return (_jsx("div", { className: "zth-dashboard-boiler-fail", children: _jsx("h1", { children: "\u0410\u0412\u0410\u0420\u0418\u042F \u041A\u041E\u0422\u041B\u0410" }) }));
    }
    else {
        return null;
    }
}
